import React from "react";

const style = {
  badge: {
    borderRadius: "2px",
    width: "84px",
    height: "20px",
    padding: "0 8px",
    fontSize: "10px",
    fontWeight: "600",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center"
  },
  green: {
    backgroundColor: "#2BAD7033",
    color: "#2BAD70"
  },
  red: {
    backgroundColor: "#DA525233",
    color: "#DA5252"
  },
  blue: {
    backgroundColor: "#0962AD26",
    color: "#0962AD"
  },
  purple: {
    backgroundColor: "#7C3AED26",
    color: "#7C3AED"
  },
  yellow: {
    backgroundColor: "#D9770626",
    color: "#B45309"
  }
};

const Badge = ({ text, color, icon }) => {
  return (
    <div style={{ ...style.badge, ...style[color] }}>
      {icon && <img src={icon} alt="Badge" style={{ marginRight: "8px" }} />}

      {text}
    </div>
  );
};

export default Badge;
